import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/QualityPromise.css';

import advancedProtectionIcon from '../assets/advancedProtectionIcon.png';
import resilientBuildIcon from '../assets/resilientBuildIcon.png';
import ecoSmartIcon from '../assets/ecoSmartIcon.png';

const QualityPromise = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section
      className="quality-promise"
      id="quality"
      data-aos="fade-up"
      data-aos-offset="150"
      data-aos-duration="1200"
    >
      <h2>Our Quality Promise</h2>
      <p>
        At GUCH Doors, we commit to delivering unparalleled performance, cutting-edge technology, and modern design.
        Our doors combine durability, security, and energy efficiency, ensuring a perfect blend of functionality and style.
      </p>

      <div className="quality-icons">
        <div className="icon">
          <img src={advancedProtectionIcon} alt="Advanced Protection" />
          <h4>Elite Security</h4>
          <p>Our doors feature advanced protection with smart-locking mechanisms, ensuring maximum security for your home.</p>
        </div>

        <div className="icon">
          <img src={resilientBuildIcon} alt="Resilient Build" />
          <h4>Unyielding Durability</h4>
          <p>Engineered for the toughest conditions, our doors are designed to endure harsh weather, impact, and time.</p>
        </div>

        <div className="icon">
          <img src={ecoSmartIcon} alt="Eco Smart Technology" />
          <h4>Eco-Friendly Performance</h4>
          <p>With smart insulation and energy-efficient designs, our doors help you save energy while reducing your carbon footprint.</p>
        </div>
      </div>
    </section>
  );
};

export default QualityPromise;
